import { Elements } from '@stripe/react-stripe-js';
import { Stripe, StripeElementsOptions } from '@stripe/stripe-js';
import StripeCardForm from './StripeCardForm';

type StripeAddCardProps = {
  shouldShowModel: boolean;
  stripePromise: Promise<Stripe | null>;
  options: {
    clientSecret?: string;
    locale?: StripeElementsOptions['locale'];
  };
  onCloseAddCardForm: (shouldRefresh: boolean) => void;
};

function StripeAddCard({
  shouldShowModel,
  stripePromise,
  options,
  onCloseAddCardForm,
}: StripeAddCardProps) {
  return (
    <>
      {options.clientSecret && (
        <Elements stripe={stripePromise} options={options}>
          <StripeCardForm
            shouldShowModel={shouldShowModel}
            onCloseAddCardForm={onCloseAddCardForm}
          />
        </Elements>
      )}
    </>
  );
}

export default StripeAddCard;
